import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { withPather } from "react-pather";
import { Button } from "@mui/material";
import { AddLinkRounded } from "@mui/icons-material";

const GetStartedButton = ({ pather, label = "Get Started", icon = false }) => {
  return (
    <motion.div
      whileHover={{
        scale: 1.02, // Scale up when hovered
        transition: { type: "spring", stiffness: 300, damping: 20 }, // Smooth transition
      }}
      whileTap={{
        scale: 0.95, // Scale down when clicked (tap)
        transition: { type: "spring", stiffness: 300, damping: 20 }, // Smooth transition
      }}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Button
        variant="contained"
        component={Link}
        to={pather.front.shorten}
        sx={{
          p: 2,
          borderRadius: "30px",
          maxWidth: { xs: "100%", sm: "350px" },
          width: "100%",
          boxShadow:
            "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;",
          textTransform: "none",
          fontWeight: "bold",
          fontSize: "16px",
          display: "flex",
          gap: 2,
        }}
      >
        {label}
        {icon && <AddLinkRounded />}
      </Button>
    </motion.div>
  );
};

export default withPather()(GetStartedButton);